import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoVisa24 = t0 => {
  const $ = _c(4);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.9027 8.78077L10.5665 15.0276H8.95034L10.2867 8.78077H11.9027ZM18.7019 12.8144L19.5525 10.4686L20.042 12.8144H18.7019ZM20.5056 15.0276H22L20.6945 8.78077H19.316C19.0053 8.78077 18.7435 8.9609 18.6275 9.23867L16.2026 15.0276H17.8999L18.2368 14.0947H20.3099L20.5056 15.0276ZM16.2868 12.9882C16.2938 11.3396 14.0077 11.2483 14.023 10.5116C14.0279 10.2878 14.2415 10.0494 14.7082 9.98839C14.9396 9.9586 15.5782 9.93443 16.3021 10.268L16.5852 8.94277C16.1964 8.80213 15.6961 8.66669 15.0735 8.66669C13.4759 8.66669 12.352 9.51532 12.343 10.7315C12.3328 11.6309 13.1459 12.1323 13.7572 12.4319C14.3875 12.738 14.5987 12.9343 14.5956 13.2078C14.5912 13.627 14.093 13.8126 13.629 13.8196C12.8161 13.8322 12.3449 13.5998 11.9693 13.4248L11.6759 14.7942C12.0542 14.9673 12.7511 15.118 13.4727 15.1257C15.1712 15.1257 16.2817 14.287 16.2868 12.9882ZM9.59342 8.78077L6.97489 15.0276H5.26681L3.97812 10.0422C3.90001 9.73562 3.83186 9.62294 3.59427 9.4934C3.20565 9.28237 2.56411 9.08496 2 8.96216L2.03822 8.78077H4.78812C5.13839 8.78077 5.45353 9.01387 5.53376 9.41739L6.21449 13.0325L7.89559 8.78077H9.59342Z" fill="#1434CB" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== ariaLabel || $[2] !== className) {
    t2 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}</svg>;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default IcoVisa24;